/**************************************************************
8/14/17
Main dashboard for displaying all time management related data
Alexander Self

***************************************************************/
import { FETCH_DASHBOARD_DATA, FETCH_INFO_BY_LOCATION, ENLARGE_GRAPHS, FETCH_HEADCOUNT,
  SORT_BY_OPERATION, FETCH_MISSING_TIMESHEETS /*, FETCH_HOURS_BY_FIELD*/ } from '../actions/types';
import moment from 'moment';
const initState = {
  employeeAttendance: {
    all: [], // Both locations to show initially
    displaying: []
  },
  fieldHours: {
    all: [], // Both locations to show initially
    displaying: []
  },
  bagDensities: {
    all: [],
    displaying: []
  },
  leaderBoard: { /* Displays a leaderboard of bag counts + total lbs collected */
    all: [],
    displaying: [],
    totalLbs: 0 // Calculates total lbs of
  },
  laborHours: {
    all: [],
    tHours: [], // To show time series in Sparkline
    tReg: [],
    tOT: [],
    tDT: [],
    totalHours: 0,
    totalRegtime: 0,
    totalOvertime: 0,
    totalDoubletime: 0
  },
  equipmentHours: [],
  hoursByDepartment: [],
  headCount: [],
  empsWOTS: {
    data: [],
    date: '',
    total: 0
  },
  headCountDate: '',
  graphSize: '6'
};


export default function DashboardReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_DASHBOARD_DATA:
      let empsWOTS = {
        data: action.payload.empsWOTS.data,
        date: action.payload.empsWOTS.date,
        total: action.payload.empsWOTS.total
      };
      if (moment(action.payload.empsWOTS.date).day() === 0 || moment(action.payload.empsWOTS.date).day() === 6) {
        empsWOTS = {
          data: [],
          date: '',
          total: 0
        };
      }
      return { ...state,
        /*fieldHours: {
          all: action.payload.fieldHours,
          displaying: action.payload.fieldHours
        },
        bagDensities: {
          all: action.payload.bagDensities,
          displaying: action.payload.bagDensities
        },
        leaderBoard: {
          all: action.payload.leaderBoard,
          displaying: action.payload.leaderBoard,
          totalLbs: action.payload.leaderBoard.reduce((acc, val, i) => { return acc + val.totalLbs }, 0)
        },
        laborHours: {
          all: action.payload.totalLaborHourSums,
          tHours: action.payload.totalLaborHourSums.map((i) => i.totalHours),
          tReg: action.payload.totalLaborHourSums.map((i) => i.totalRegtime),
          tOT: action.payload.totalLaborHourSums.map((i) =>i.totalOvertime),
          tDT: action.payload.totalLaborHourSums.map((i) => i.totalDoubletime),
          totalHours: action.payload.totalLaborHourSums.reduce((acc, val, i) => { return acc + val.totalHours }, 0),
          totalRegtime: action.payload.totalLaborHourSums.reduce((acc, val, i) => { return acc + val.totalRegtime }, 0),
          totalOvertime: action.payload.totalLaborHourSums.reduce((acc, val, i) => { return acc + val.totalOvertime }, 0),
          totalDoubletime: action.payload.totalLaborHourSums.reduce((acc, val, i) => { return acc + val.totalDoubletime }, 0)
        },
        hoursByDepartment: action.payload.hoursByDepartment,
        */
        equipmentHours: action.payload.equipmentHours,
        headCount: action.payload.headCount,
        headCountDate: action.payload.date,
        empsWOTS
      };
    case FETCH_HEADCOUNT:
      return { ...state,
        headCount: action.payload,
        headCountDate: action.date
      };
    case FETCH_INFO_BY_LOCATION:
      return handleLocationSwitch(state, action.payload);
    case ENLARGE_GRAPHS:
      let graphSize;
      if (state.graphSize === '6') graphSize = '12';
      else graphSize = '6';
      return { ...state,
        graphSize
      };
    case SORT_BY_OPERATION:
      switch (action.payload) {
        case 'dashboard-operating-equipment':
          return { ...state,
            equipmentHours: [ ...state.equipmentHours.sort((a,b) => a.operatingHours > b.operatingHours ? -1 : 1) ]
          };
        case 'dashboard-garage-equipment':
          return { ...state,
            equipmentHours: [ ...state.equipmentHours.sort((a,b) => a.garageHours > b.garageHours ? -1 : 1) ]
          };
        default:
          return state;
      }
    case FETCH_MISSING_TIMESHEETS:
      return { ...state,
        empsWOTS: {
          data: action.payload.empsWOTS.data,
          date: action.payload.empsWOTS.date,
          total: action.payload.empsWOTS.total
        }
      }
    /*case FETCH_HOURS_BY_FIELD:
      return { ...state,
        fieldHours: {
          all: action.payload,
          displaying: action.payload
        }
      };*/
    default:
      return state;
  }
}
/* Employee attendance would autosort forwhatever reason on each re-render */
function handleLocationSwitch(state, action) {
  switch (action) {
    case 'field-both-loc':
      return { ...state,
        fieldHours: { ...state.fieldHours, displaying: state.fieldHours.all },
        employeeAttendance: { ...state.employeeAttendance, displaying: state.employeeAttendance.displaying.sort(sortByDate) }
      };
    case 'field-kau-loc':
      return { ...state,
        fieldHours: { ...state.fieldHours, displaying: state.fieldHours.all.filter((f) => f.location === '71') },
        employeeAttendance: { ...state.employeeAttendance, displaying: state.employeeAttendance.displaying.sort(sortByDate) }
      };
    case 'field-keaau-loc':
      return { ...state,
        fieldHours: { ...state.fieldHours, displaying: state.fieldHours.all.filter((f) => f.location === '72') },
        employeeAttendance: { ...state.employeeAttendance, displaying: state.employeeAttendance.displaying.sort(sortByDate) }
      };
    case 'density-both-loc':
      return { ...state,
        bagDensities: { ...state.bagDensities, displaying: state.bagDensities.all },
        employeeAttendance: { ...state.employeeAttendance, displaying: state.employeeAttendance.displaying.sort(sortByDate) }
      };
    case 'density-kau-loc':
      return { ...state,
        bagDensities: { ...state.bagDensities, displaying: state.bagDensities.all.filter((f) => f.location === '71') },
        employeeAttendance: { ...state.employeeAttendance, displaying: state.employeeAttendance.displaying.sort(sortByDate) }
      };
    case 'density-keaau-loc':
      return { ...state,
        bagDensities: { ...state.bagDensities, displaying: state.bagDensities.all.filter((f) => f.location === '72') },
        employeeAttendance: { ...state.employeeAttendance, displaying: state.employeeAttendance.displaying.sort(sortByDate) }
      };
    case 'leaderBoard-both-loc':
      return { ...state,
        leaderBoard: { ...state.leaderBoard, displaying: state.leaderBoard.all },
        employeeAttendance: { ...state.employeeAttendance, displaying: state.employeeAttendance.displaying.sort(sortByDate) }
      };
    case 'leaderBoard-kau-loc':
      return { ...state,
        leaderBoard: { ...state.leaderBoard, displaying: state.leaderBoard.all.filter((f) => f.location === '71') },
        employeeAttendance: { ...state.employeeAttendance, displaying: state.employeeAttendance.displaying.sort(sortByDate) }
      };
    case 'leaderBoard-keaau-loc':
      return { ...state,
        leaderBoard: { ...state.leaderBoard, displaying: state.leaderBoard.all.filter((f) => f.location === '72') },
        employeeAttendance: { ...state.employeeAttendance, displaying: state.employeeAttendance.displaying.sort(sortByDate) }
      };
    case 'attendance-both-loc':
      return { ...state,
        employeeAttendance: { ...state.employeeAttendance, displaying: state.employeeAttendance.all.sort(sortByDate) }
      };
    case 'attendance-kau-loc':
      return { ...state,
        employeeAttendance: { ...state.employeeAttendance, displaying: state.employeeAttendance.all.filter((f) => f.location === '71').sort(sortByDate) }
      };
    case 'attendance-keaau-loc':
      return { ...state,
        employeeAttendance: { ...state.employeeAttendance, displaying: state.employeeAttendance.all.filter((f) => f.location === '72').sort(sortByDate) }
      };
    default:
      return state;
  }
}

export function sortByDate(a,b) {
  return moment(a.workdate) - moment(b.workdate);
}


































/* END */



// WEBPACK FOOTER //
// ./src/reducers/dashboard_reducer.js